export default __webpack_public_path__ + "static/media/fig4.e4a4a4a4.jpg";